const attendanceNotes = {
  'attendanceNotes.notes': 'Notes',
  'attendanceNotes.notesPlaceholder': 'Write your annotations here',
  'attendanceNotes.footer': "Content will be saved at the call's end.",
};

export default attendanceNotes;
